import styled from "styled-components";

export const ExplantsInvestigationReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 82vw;
`;
